const phoneNumber = {
  call: '(415) 523-3762',
  text: '(262) 287-9856',
  text_1: '(415) 523-3727',
}

export default phoneNumber
